import { IPaymentListItem } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const getCalculationPayments = (id: string): Promise<IPaymentListItem[]> =>
  API.get(`/api/accommodation/calculations/${id}/payments`).then(response => response?.data);
